export const FORGOT_PW_INIT = 'FORGOT_PW_INIT'

export const FORGOT_PW_REQUEST = 'FORGOT_PW_REQUEST'
export const FORGOT_PW_REQUEST_SUCCESS = 'FORGOT_PW_REQUEST_SUCCESS'
export const FORGOT_PW_REQUEST_FAILURE = 'FORGOT_PW_REQUEST_FAILURE'

export const FORGOT_PW_RESET = 'FORGOT_PW_RESET'
export const FORGOT_PW_RESET_SUCCESS = 'FORGOT_PW_RESET_SUCCESS'
export const FORGOT_PW_RESET_FAILURE = 'FORGOT_PW_RESET_FAILURE'
